export default __webpack_public_path__ + "static/media/HowTo.ec139467.txt";